import { isAxiosError } from 'axios';
import { z } from 'zod';

const mergedSchema = z.object({
  code: z.literal('tracker_merged'),
  details: z.object({ targetTrackerId: z.string().min(1) }),
});
const upgradingSchema = z.object({ code: z.literal('trackers_upgrading') });

export type TrackerOpenFailure =
  | { kind: 'merged'; targetTrackerId: string }
  | { kind: 'upgrading' };

/**
 * Why a tracker could not be opened, when the server said: it was merged into
 * another board, or the organization's trackers are being upgraded. Anything
 * else is null and reads as not found.
 */
export function trackerOpenFailure(error: unknown): TrackerOpenFailure | null {
  if (!isAxiosError(error)) return null;
  const body: unknown = error.response?.data;
  const merged = mergedSchema.safeParse(body);
  if (merged.success)
    return { kind: 'merged', targetTrackerId: merged.data.details.targetTrackerId };
  return upgradingSchema.safeParse(body).success ? { kind: 'upgrading' } : null;
}
